import axios from 'axios';
import qs from 'qs';
import router from "@/router";
import VueCookies from "vue-cookies";

export const base = {
  post,
  put,
  get,
  getFromPartner,
  deleteItem,
  uploadImage,
  uploadImageDMS,
  preImport
}

async function post(
  url,
  params,
  is_qs = false, // query string
  is_login = true // có cần login không?
) {
  let token = VueCookies.get('token');
  if (VueCookies.get('token') && VueCookies.get('token').indexOf('-') > 0) {
    token = VueCookies.get('token').split('-')[0];
  }
  const refactorInput = is_qs ? qs.stringify(params) : params
  const headers = is_login ? {'user-token': token} : {'access-token': process.env.VUE_APP_ACCESS_TOKEN || 'DL3XL98W21MNEZW1YVYY4YPVOVGQKYQZZREX'};
  return await axios.post(process.env.VUE_APP_API_URL+`/api/v1/${url}`, refactorInput, {headers})
    .then(response => response)
    .catch(error => {
      if (error.response.status === 403) {
        return router.push('/logout');
      }
      return {
        data: {
          error: {
            message: error.response.data.error.message,
            code: error.response.status
          }
        }
      }
    });
}

async function put(url, params, is_login = true) {
  let token = VueCookies.get('token');
  if (VueCookies.get('token') && VueCookies.get('token').indexOf('-') > 0) {
    token = VueCookies.get('token').split('-')[0];
  }
  const headers = is_login ? {'user-token': token} : {'access-token': process.env.VUE_APP_ACCESS_TOKEN || 'DL3XL98W21MNEZW1YVYY4YPVOVGQKYQZZREX'};
  return await axios.put(process.env.VUE_APP_API_URL+`/api/v1/${url}`, params, {headers})
    .then(response => response)
    .catch(error => {
      if (error.response.status === 403 || error.response.status === 401) {
        return router.push('/logout');
      }
      return {
        data: {
          error: {
            message: error.response.statusText,
            code: error.response.status
          }
        }
      }
    });
}

async function get(url, params, is_login = true) {
  let token = VueCookies.get('token');
  if (VueCookies.get('token') && VueCookies.get('token').indexOf('-') > 0) {
    token = VueCookies.get('token').split('-')[0];
  }
  const headers = is_login ? {'user-token': token} : {};
  return await axios.get(process.env.VUE_APP_API_URL+`/api/v1/${url}`, {headers, params: params})
    .then(response => response)
    .catch(error => {
      if (error.response.status === 403 || error.response.status === 401) {
        return router.push('/logout');
      }
      return {
        data: {
          error: {
            message: error.response.statusText,
            code: error.response.status
          }
        }
      }
    });
}

async function getFromPartner(url, params, headers) {
  return await axios.get(process.env.VUE_APP_API_URL+`/api/v1/${url}`, {headers, params: params})
    .then(response => response)
    .catch(error => {
      return {
        data: {
          error: {
            message: error.response.statusText,
            code: error.response.status
          }
        }
      }
    });
}

async function deleteItem(url, is_login = true) {
  let token = VueCookies.get('token');
  if (VueCookies.get('token') && VueCookies.get('token').indexOf('-') > 0) {
    token = VueCookies.get('token').split('-')[0];
  }
  const headers = is_login ? {'Authorization': 'Bearer ' + token} : {};
  return await axios.delete(process.env.VUE_APP_API_URL+`/api/v1/${url}`, {headers})
    .then(response => response)
    .catch(error => {
      return {
        data: {
          error: {
            message: error.response.statusText,
            code: error.response.status
          }
        }
      }
    });
}

async function uploadImage(file) {
  const headers = {
    'Content-Type': 'multipart/form-data'
  };
  const token = 'YI6INHP5PDN1573KSJD2CRN91GO3VAM9';
  const url = `https://upload.foodbook.vn/upload/UploadFileServlet?access_token=${token}&bucket=hrm`;
  return await axios.post(url, file, {headers})
    .then(response => response)
    .catch(error => {
      return {
        data: {
          error: {
            message: error.response.statusText,
            code: error.response.status
          }
        }
      }
    });
}

async function uploadImageDMS(file, params) {
  let token = VueCookies.get('token');
  if (VueCookies.get('token') && VueCookies.get('token').indexOf('-') > 0) {
    token = VueCookies.get('token').split('-')[0];
  }
  const headers = {
    'Content-Type': 'multipart/form-data',
    'user-token': token
  };
  return await axios.post(process.env.VUE_APP_API_URL+`/api/v1/upload/images`, file, {headers, params})
    .then(response => response)
    .catch(error => {
      return {
        data: {
          error: {
            message: error.response.statusText,
            code: error.response.status
          }
        }
      }
    });
}

async function preImport(file, params) {
  let token = VueCookies.get('token');
  if (VueCookies.get('token') && VueCookies.get('token').indexOf('-') > 0) {
    token = VueCookies.get('token').split('-')[0];
  }
  const headers = {
    'Content-Type': 'multipart/form-data',
    'user-token': token
  };
  return await axios.post(process.env.VUE_APP_API_URL+`/api/v1/pre-import/catalogs`, file, {headers, params})
    .then(response => response)
    .catch(error => {
      return {
        data: {
          error: {
            message: error.response.statusText,
            code: error.response.status
          }
        }
      }
    });
}
